import useGetApi from 'src/api/useGetApi';
import CurrentUser from 'src/types/CurrentUser';

import {
  AUTH_QUERY_RETRY_DELAY_MS,
  shouldRetryAuthQuery,
} from './authQueryConfig';

interface Response {
  user: CurrentUser | null;
}

const useCurrentUser = () => {
  return useGetApi<Response>({
    endpoint: 'auth/me',
    options: {
      retry: shouldRetryAuthQuery,
      retryDelay: AUTH_QUERY_RETRY_DELAY_MS,
    },
  });
};

export default useCurrentUser;
